import { useEffect, forwardRef, useRef } from 'react'
import GameObject from './GameObject'

const Text = forwardRef(({
  args,
  children,
  ...props
}, externalRef) => {

  const localRef = useRef()
  const ref = externalRef || localRef

  useEffect(() => {
    if (typeof children === 'string') {
      ref.current?.setText(children)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [children])

  return (
    <GameObject
      ref={ref}
      type="Text"
      args={[
        args?.[0] ?? props.x,
        args?.[1] ?? props.y,
        typeof children === 'string' ? children : args?.[2] ?? "",
        args?.[3] ?? props.style
      ]}
      {...props}
    />
  )
})
Text.displayName = 'Text'
export default Text
